"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LambdaHttpServices = void 0;
// HTTP Services
var LambdaHttpServices;
(function (LambdaHttpServices) {
    LambdaHttpServices["GET_SERVICES"] = "get-services";
    LambdaHttpServices["GET_VOICES"] = "get-voices";
    LambdaHttpServices["PLAY"] = "play";
    LambdaHttpServices["GENERATE_VIDEO"] = "generate-video";
    LambdaHttpServices["GET_VIDEO_STATUS"] = "get-video-status";
    LambdaHttpServices["GET_VIDEO"] = "get-video";
    LambdaHttpServices["BATCH_CREATE"] = "batch-create";
    LambdaHttpServices["BATCH_STATUS"] = "batch-status";
})(LambdaHttpServices || (exports.LambdaHttpServices = LambdaHttpServices = {}));
//# sourceMappingURL=lambdaTypes.js.map